import { render, staticRenderFns } from "./TreatmentOpenToGetting.vue?vue&type=template&id=6147ba50&"
import script from "./TreatmentOpenToGetting.vue?vue&type=script&lang=js&"
export * from "./TreatmentOpenToGetting.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentOpenToGetting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports